import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import './PartnerLogo.scss';

export interface Props {
  name: string;
  logoUrl: string;
}

function PartnerLogo({name, logoUrl}: Props): ReactElement {
  return (
    <div className="partnerLogo">
      <div className="partnerLogo__text">
        <FormattedMessage id="phoenix.partners.title" />
      </div>
      <div className="partnerLogo__image">
        <img src={logoUrl} alt={name} />
      </div>
    </div>
  );
}

export default PartnerLogo;
